// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__lb5H4","spinnerImage":"LoadingSpinner_spinnerImage__ffUST"};